<template>
	<div ref="allHeight" class="rightCont" style="position:fixed;height: auto;">
		<div ref="rightBigBox" :class="showPosi==1?'rightCont1':showPosi==2?'rightCont2':'rightCont3'">
			<div ref='rightBox'>
				<div class="firstB">
					<img class="fstPic" src="../assets/images/zx.png" />
					<el-button @click="drawer = true" type="primary" class="callNow">
					  <span style="margin-left: unset !important">立即咨询</span>
					</el-button>
				</div>
				<el-drawer
				  title=""
				  :append-to-body='true'
				  :visible.sync="drawer"
				  :direction="direction"
				  :before-close="handleClose">
				  <div class="contact-form">
					  <div class="contact-titl">预约咨询</div>
					  <input type="text" v-model="name" class="cont-ipt" placeholder="姓名"/>
					  <input type="number" v-model="mobile" class="cont-ipt" placeholder="手机号码"/>
					  <input type="text" v-model="conpany" class="cont-ipt" placeholder="公司名称(选填)"/> 
					  <input type="text" v-model="address" class="cont-ipt" placeholder="所在地区（选填）"/> 
					  <div class="confirm-btn" @click="subAsk">提交</div>
				  </div>
				</el-drawer>
				<el-dialog
					title=""
					:visible.sync="dialogVisible"
					width="30%"
					:before-close="handleClose"
					:append-to-body='true'>
					<div>
						<img class="pop-pic" src="https://aido-pet.oss-cn-shenzhen.aliyuncs.com/wxma-qrcode/2021-04-19/QoLENQuXGDSRUzOsxeHd.jpg" />
						<div class="free-use">扫码立即体验</div>
					</div>
				</el-dialog>
				<el-button :plain="false" @click="open2"></el-button>
			</div>
		</div>
	</div>
</template>

<script>
import request from '../utils/request.js'
export default{
	name:'rightCont', 
	data(e) { 
	  return {
		name:null,
		mobile:null,
		conpany:null,
		email:null,
		address:null,
		product:null,
		drawer: false,
		direction: 'rtl',
		dialogVisible:false,
		showPosi:1,
		boxHeight:'',
		rightBigBoxH:'',
		totalHeight:'',
		clientHeight:'',
		allHeight:''
	  };
	},  
	openMe(_this)
	{ 
		_this.drawer = true;  
	},
	methods: { 
		cflag(flag)
		{
			this.drawer = flag
		},
		handleClose(done) {
			done();
		},
		open2() {
			this.$message({
			    message: '提交成功，稍后我们将会有客服人员联系您，请保持电话畅通',
			    type: 'success'
			});
		 },
		handleScroll(e) {
			var that = this
			var top = Math.floor(document.documentElement.scrollTop)
			var allBox = 268 + that.allHeight
			let milens = allBox - parseInt(that.clientHeight)-50
			var tops = parseInt(top)  + parseInt(that.clientHeight) 
			if(top > that.boxHeight){
				if(top>milens){
					that.showPosi = 3
				}else{
					that.showPosi = 2
				}
			}else if(top<=that.boxHeight){
				that.showPosi=1  
			}
		},
		async subAsk () {
			console.log('xxxx', this);
			if(!this.name || !this.mobile){
				this.$message({
				    message: '请输入姓名和手机号',
				    type: 'info'
				});
				return
			}
			if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
					this.$message({
						message: '请填写正确的手机号',
						type: 'info'
					});
			      return;
			   }
			const res = await request({
				method:'POST', 
				url:'/soft/consult/save', 
				data:{
					name:this.name,
					mobile:this.mobile,
					comp:this.conpany,
					email: '',
					addr:this.address,
					prod: 'MOMI智慧自助空间系统',
					type:0
				}
			})
			if(res.code!=0) return
			this.drawer = false,
			this.open2()
		}
	},
	mounted() {
		var that = this
		window.addEventListener("scroll", that.handleScroll, true)	
		that.clientHeight = `${document.documentElement.clientHeight}`
		that.boxHeight = that.$refs.rightBox.offsetHeight
		that.allHeight = that.$refs.allHeight.offsetHeight
		if(that.clientHeight>that.boxHeight){
			that.showPosi = 2
		}else{
			that.showPosi = 1
		}
	}
	
}
</script>

<style>
	@media screen and (max-width: 1200px) {
		.rightCont{
			display: none;
		}
	}
	.el-button{
		 border: unset !important;
		 
	}
	.el-popover{
		min-width: unset !important; 
	}
	.free-use{
		font-size: 20px;
		color: #ff6a00;
		margin-top: 50px;
		text-align: center;
	}
	.pop-pic{
		width: 206px;
		height: 206px;
		display: block;margin: 0 auto;
	}
	.confirm-btn{
		margin-top: 5px;
		height: 40px;
		width: 100%;
		background: #155bd4;
		border: none;
		outline: none;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		cursor: pointer;
		border-radius: 2px;
		text-align: center;
		line-height: 40px;
	}
	.thImg-pic{
		padding: 10px;
	}
	.cont-ipt{
		margin-bottom: 24px;
		padding: 6px 10px;
		height: 18px;
		width: 208px;
		background: #fff;
		border: 1px solid #dcdee0;
		border-radius: 2px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #323233;
		outline: none;
	}
	.contact-titl{
		padding-top: 20px;
		padding-bottom: 20px;
		line-height: 27px;
		font-weight: 600;
		font-size: 20px;
		color: #323233;
		letter-spacing: 0;
	}
	.thImg1{
		height: 120px;
		width: 120px;
	}
	.contact-form{
		text-align: left;
		padding: 10px 30px;
	}
	.el-drawer{
		width:290px !important ;
	}
	span{
		/* color:#155bd4 !important; */
		margin-left: unset !important;
	}
	.el-drawer__body{
		z-index: 99999999999;
	}
	.rightCont1{
		width: 312px;
		margin-left: 16px;
	}
	.rightCont2{
		width: 312px;
		margin-left: 16px;
		top: 110px;
		position: fixed;
	}
	.rightCont3{
		width: 312px;
		margin-left: 16px;
		bottom: 0;
		position: absolute;
	}
	.fistLit{
		display: flex;
	}
	.centbox{
		width: 30px;
		float: left;
	}

	.test{
		color: #fff !important;
		border: 1px solid #fff !important;
		margin: 12px 20px 0 !important;
		font-size: 14px !important;
		line-height: 36px !important;
		display: block !important;
		border-radius: 2px !important;
		cursor: pointer !important;
		width: 224px !important;
		padding: unset !important;
	}
	.callNow span{
		height:25px;
		line-height:25px;
		padding:5px;
		color: #fff;
	}
	.firstB{
		position: fixed;
		right: 0;
		background-color: #fff;
		padding: 24px 24px 21px;
		margin-bottom: 16px;
		border-radius:10px;
	}
</style>
